import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
export const DatePickerWhite = styled(DatePicker)({
  "& label.Mui-focused": {
    color: `rgb(245,245,245)`,
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: `rgba(255, 255, 255, 0.5)`,
      border: "none !important",
    },
    "&:hover fieldset": {
      borderColor: `rgba(255, 255, 255, 0.5)`,
    },
    "&.Mui-focused fieldset": {
      borderColor: `rgba(255, 255, 255, 0.5)`,
    },
  },
  "& .MuiInputLabel-root": {
    color: `rgb(245,245,245)`,
  },
  "& input": {
    color: `rgb(245,245,245)`,
  },
  "& .MuiSvgIcon-root": {
    color: `rgb(245,245,245)`,
  },
});
